module.exports = __webpack_public_path__ + "img/preview-lg.afb6b22b.png";